/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Modal, withStyles } from '@material-ui/core'
import styles from './styles'
import { PreviewHeader } from './components'
import { useSelector } from 'react-redux'
import URL from 'src/api/url'
const CoursePreview = props => {
  const { handleCloseModal, classes, isModalOpen } = props
  const course = useSelector(state => state.course.course)
  const [width, setWidth] = React.useState('100%')
  const [height, setHeight] = React.useState('100%')
  const [type, setType] = React.useState('desktop')
  return (
    <Modal
      open={isModalOpen}
      onClose={() => handleCloseModal()}
      className={classes.modal}
      BackdropProps={{
        style: {
          display: 'none',
        },
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <PreviewHeader
          handleCloseModal={handleCloseModal}
          setHeight={setHeight}
          setWidth={setWidth}
          setType={setType}
          type={type}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1,
          }}
        >
          <div
            style={{
              padding: type != 'desktop' ? '24px' : '0',
              borderRadius: type != 'desktop' ? '48px' : '0',
              backgroundColor: type != 'desktop' ? '#f5f5f5' : 'transparent',
              width: width,
              height: height,
            }}
          >
            <iframe
              width={'100%'}
              height={'100%'}
              style={{
                border: '0',
                borderRadius: type != 'desktop' ? '24px' : '0',
              }}
              title={course?.name}
              src={URL.APP_URL + course?.code}
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </Modal>
  )
}
export default withStyles(styles)(CoursePreview)
